/* global mixpanel */
export function settingReceiptStart ({outletIds}) {
  mixpanel.track('Setting Receipt Start', {
    'Current Selected Outlet': outletIds
  })
}

export function settingReceiptChangeOutlet ({outletIds}) {
  mixpanel.track('Setting Receipt Change Outlet', {
    'Current Selected Outlet': outletIds
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/settings/receipt.js